/**
* Remove comma from string
*
* @param {string} Str - string
*/
export function removeComma(str){
  while (str.search(",") >= 0) {
      str = (str + "").replace(',', '');
  }
  return str;
}


/**
* Capital first letter of string
*
* @param {string} Str - string
*/
export function capitaliseFirstLetter(str){
   return str.charAt(0).toUpperCase() + str.slice(1);
}


/**
* Lowercase first letter of string
*
* @param {string} Str - string
*/
export function lowerCaseFirstLetter(str){
   return str.toLowerCase();
}


/**
* Replace space with dash
*
* @param {string} Str - string
*/
export function replaceSpaceDash(str){
 return str.replace(/\s+/g, '-');
}


/**
* Replace space with dash
*
* @param {string} Str - string
*/
export function replaceDashSpace(str){
 try{ return str.replace('-', ' ');
 }catch(e){ return; }
}


/**
* Replace empty space
*
* @param {string} Str - string
*/
export function replaceSpace(str){
  return str.replace(/\s+/g, '');
}


/**
* Replace space after daash
*
* @param {string} Str - string
*/
export function removeSpaceAfter(str){
 return str.indexOf(" ") !== -1 ? str.substring(0, str.indexOf(" ")) : str;
}


/**
* Appends class name based on character length
*
* @param {string} Str - string
* @param {number} num - number of letters
* @param {string} classValue - class to append
* @param {boolean} mobilecheck - check if mobile size
*/
export function strCount(str, num, classValue, mobileCheck = false){
 if(!mobileCheck){
  return ((str !== undefined || str.length !== 0 || str !== null) && str.length > num)  ? classValue : '';
 }else{
   if(window.innerWidth < 415) return str.length > num ? classValue : '';
 } 
}


/**
* Replace space after dash
*
* @param {string} Str - string
*/
export function removeByLastIndex(str, char){
 return str.substring(0, str.lastIndexOf(char))
}


/**
* Plural string helper
*
* @param {string} Str - string
* @param {number} Num - number
*/
export function pluralHelper(str, num){
  return num > 1 ? `${str}s` : str;
}




/**
* Dash list helper
*
* @param {string} dashStr - string
*/
export function renderDashedList(dashStr){
  try{
    if(dashStr !== undefined){
        let str = dashStr.replace(/(\r\n|\n|\r)/gm,"");
        let arr = str.split("- ");
        arr.shift();
        return arr;
    }
  }catch(e){
    return [];
  }
}